import FileStackClient from "../../utils/filestack";
import {tempStoreOptions} from "./utils";

export function doTransformImage(observer, file, transformations) {
  // transform image at given url and then store the transformed image in temp storage
  let newUrl = FileStackClient.transform(file.url, transformations);

  FileStackClient.storeURL(newUrl, tempStoreOptions).then((result) => {
    try {
      observer.next(result);
    } catch (err) {
      observer.error(err);
      return;
    }

    observer.complete();
  }).catch((reason) => {
    observer.error(reason);
  });
}


// WEBPACK FOOTER //
// ./public/observables/lettables/transformImage.js